import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import * as Constants from './../../helpers/constants'
import UserlistPage from '../user_list_page';
import ClearoutIndividualUserInfo from '../individual_user_info/clearout_individual_user_info';
import Coupons from '../coupons/coupons';
import ManageAbuse from '../abuse/manage_abuse';
import UpdateHistory from '../update_history/abuse_update_history';
import AbuseLogs from '../abuse_view_logs/abuse_view_logs';
import UserActivities from '../user_activities/user_activities';
import ServiceLists from '../service_list';
import ProductList from './../products/component/list'
import CreateProduct from './../products/component/create'
import GeneratePurchaseURL from './../products/component/generate_url'
import MiscellaneousApi from '../miscellaneous';
import PlanInfo from '../product_info/plan_info_card'


const CLIENT = Constants.CLIENTS.CLEAROUTPHONE.NAME

const clearoutphoneRouter = createBrowserRouter([
  {
    id: 'dashboard-clearoutphone-route',
    path: CLIENT,
    children: [
      {
        id: 'dashboard-clearout-phone-users',
        path: 'users',
        element: <UserlistPage />
      },
      {
        id: 'dashboard-clearout-phone-list',
        path: 'lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.PHONE_NUMBER_VERIFIER} />
      },
      {
        id: 'clearoutphone-individual-user-info',
        path: 'individual_user_info',
        element: <ClearoutIndividualUserInfo />
      },
      {
        id: 'copcoupons',
        path: 'coupons',
        element: <Coupons />
      },
      {
        id: 'copcoupon',
        path: 'coupons/:couponId',
        element: <Coupons />
      },
      {
        id: 'dashboard-clearoutphone-manage-abuse',
        path: 'abuse_list',
        element: <ManageAbuse />
      },
      {
        id: 'dashboard-clearoutphone-view-logs',
        path: 'abuse_logs',
        element: <AbuseLogs />
      },
      {
        id: 'dashboard-clearoutphone-update-logs',
        path: 'abuse_update_logs',
        element: <UpdateHistory />
      },
      {
        id: 'dashboard-cop-user-activities',
        path: 'individual_user_activity',
        element: <UserActivities />
      },
      {
        id: 'clearoutphone-plan-list',
        path: 'plan_list',
        element: <ProductList />
      },
      {
        id: 'clearoutphone-create-plan',
        path: 'create_plan',
        element: <CreateProduct />
      },
      {
        id: 'clearoutphone-generate-purchase-url',
        path: 'generate_purchase_url',
        element: <GeneratePurchaseURL />
      },
      {
        id: 'dashboard-clearoutphone-miscellaneous-api',
        path: 'miscellaneous_api',
        element: <MiscellaneousApi />
      },
      {
        id: 'clearoutphone-plan-info',
        path: 'plan_info/:planId',
        element: <PlanInfo/>
      },
      {
        id: CLIENT + '-redirect',
        path: '*',
        element:
          <Navigate
            to={'users'}
            replace={true}
          />
      },
    ]
  }
])

export default clearoutphoneRouter
